<template>
  <div class="row">
    <!-- Client Timesheet Authorisation -->
    <div class="col-12">
      <b-card header="Client Timesheet Authorisation" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <div class="row">
          <!-- Client TS Auth Exists -->
          <div class="col-8 form-group" v-if="!hasContacts">
            <h5>No contacts available for timesheet authorization. Please add new contact.</h5>
          </div>
          <div class="col-12" v-if="hasContacts && notEmptyObject(default_timesheet_auth) && !edit_ts_auth">
            <div class="row">
              <div class="col-xl-9 form-group">
                <h5>Default Client Timesheet Authorisation and Submission Contacts</h5>
              </div>
              <div class="col-xl-3"
                v-if="!$store.state.auth.me.roles.includes('client_sub') && !$store.state.auth.me.roles.includes('client_auth')">
                <button @click.prevent="edit_levels" class="btn orcaBtn sm_btn blue_btn float-right">Edit Levels</button>
              </div>
              <div class="col-12">
                <h5 class="bp_color">Contacts with permission to Submit Timesheet Instructions to <span
                    v-if="crmType === 'payroll'">Genius Money</span><span v-else-if="crmType === 'recruitment'">V3
                    Recruitment</span></h5>
              </div>
              <div class="col-xl-4 form-group" v-for="ts_as in default_timesheet_auth" v-if="ts_as.submission_level >= 8">
                <h5 class="font-weight-bold pt-0 mb-0">{{ ts_as.contact.person.first_name }} {{
                  ts_as.contact.person.surname }}</h5>
                <p class="b3_color pt-0"
                  v-if="ts_as.contact.rel_profile.job_title_id !== null && ts_as.contact.rel_profile.job_title !== null">
                  {{
                    ts_as.contact.rel_profile.job_title.job_title
                  }}</p>
                <hr class="mt-2 mb-2">

                <div class="contact_login_text">
                  <div
                    v-if="(ts_as.contact.user !== null && Object.keys(ts_as.contact.user).length > 1) && ts_as.contact.user.active">
                    Contact has login : <span class="green_color">Yes
                    </span></div>
                  <div
                    v-else-if="(ts_as.contact.user !== null && Object.keys(ts_as.contact.user).length > 1) && !ts_as.contact.user.active">
                    Contact has login : <span class="orange_color">Disabled</span></div>
                  <div v-else>Contact has login : <span class="red_color">No</span></div>
                </div>

                <div class="contact_login_btn"
                  v-if="!$store.state.auth.me.roles.includes('client_sub') && !$store.state.auth.me.roles.includes('client_auth')">
                  <div
                    v-if="(ts_as.contact.user !== null && Object.keys(ts_as.contact.user).length > 1) && ts_as.contact.user.active">
                    <button @click.prevent="view_contact_login(ts_as.contact)"
                      class="btn orcaBtn greenBtn sm_btn">View</button>
                  </div>
                  <div
                    v-else-if="(ts_as.contact.user !== null && Object.keys(ts_as.contact.user).length > 1) && !ts_as.contact.user.active">
                    <button @click.prevent="enable_contact_login(ts_as.contact)"
                      class="btn orcaBtn greenBtn sm_btn">Enable</button>
                  </div>
                  <div v-else-if="(ts_as.contact.user === null || Object.keys(ts_as.contact.user).length === 1) && ($store.state.auth.me.roles.includes('admin') ||
                        $store.state.auth.me.roles.includes('manager'))">
                    <button @click.prevent="create_contact_login(ts_as.contact, ts_as.submission_level)"
                      class="btn orcaBtn greenBtn sm_btn">Create</button>
                  </div>
                </div>
              </div>
              <div class="col-12 form-group" v-if="submission_auth_as_well">
                <hr>
                <h5 class="bp_color">Contacts with permission to Authorise Timesheet Instructions</h5>
              </div>
              <div class="col-12 form-group" v-for="ts_as in default_timesheet_auth"
                v-if="ts_as.submission_level >= 2 && ts_as.submission_level <= 7">
                <div class="row">
                  <div class="col-xl-4"><strong class="cardLabel">Authorising Contact Level {{ ts_as.submission_level - 1
                  }}</strong></div>
                  <div class="col-xl-4">
                    <h5 class="font-weight-bold pt-0 mb-0">{{ ts_as.contact.person.first_name }} {{
                      ts_as.contact.person.surname }}</h5>
                    <p class="b3_color pt-0"
                      v-if="ts_as.contact.rel_profile.job_title_id !== null && ts_as.contact.rel_profile.job_title !== null">
                      {{
                        ts_as.contact.rel_profile.job_title.job_title
                      }}</p>
                  </div>
                  <div class="col-xl-4">
                    <div class="contact_login_text">
                      <div class="cardLabel"
                        v-if="(ts_as.contact.user !== null && Object.keys(ts_as.contact.user).length > 1) && ts_as.contact.user.active">
                        Contact has login :
                        <span class="green_color">Yes</span>
                      </div>
                      <div class="cardLabel"
                        v-else-if="(ts_as.contact.user !== null && Object.keys(ts_as.contact.user).length > 1) && !ts_as.contact.user.active">
                        Contact has
                        login :
                        <span class="orange_color">
                          Disabled</span>
                      </div>
                      <div class="cardLabel" v-else>Contact has login : <span class="red_color">No</span></div>
                    </div>

                    <div class="contact_login_btn"
                      v-if="!$store.state.auth.me.roles.includes('client_sub') && !$store.state.auth.me.roles.includes('client_auth')">
                      <div
                        v-if="(ts_as.contact.user !== null && Object.keys(ts_as.contact.user).length > 1) && ts_as.contact.user.active">
                        <button @click.prevent="view_contact_login(ts_as.contact)"
                          class="btn orcaBtn greenBtn sm_btn">View</button>
                      </div>
                      <div
                        v-else-if="(ts_as.contact.user !== null && Object.keys(ts_as.contact.user).length > 1) && !ts_as.contact.user.enabled">
                        <button @click.prevent="enable_contact_login(ts_as.contact)"
                          class="btn orcaBtn greenBtn sm_btn">Enable</button>
                      </div>
                      <div v-else-if="(ts_as.contact.user === null || Object.keys(ts_as.contact.user).length === 1) && ($store.state.auth.me.roles.includes('admin') ||
                            $store.state.auth.me.roles.includes('manager'))">
                        <button @click.prevent="create_contact_login(ts_as.contact, ts_as.submission_level)"
                          class="btn orcaBtn greenBtn sm_btn">Create</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Client TS Auth DOES NOT Exist OR editing TS Auth values -->
          <div class="col-12" v-if="(!notEmptyObject(default_timesheet_auth) || edit_ts_auth) && !$store.state.auth.me.roles.includes('client_sub') &&
              !$store.state.auth.me.roles.includes('client_auth')">
            <div class="row">
              <div class="col-12" v-if="!notEmptyObject(default_timesheet_auth)">
                <h4 class="red_color text-uppercase">This company requires setup of default contacts for Timesheet
                  Authorisation and submission to <span v-if="crmType === 'payroll'">Genius</span><span
                    v-else-if="crmType === 'recruitment'">V3</span>.</h4>
                <hr>
              </div>
              <div class="col-12">
                <ValidationObserver ref="editTSauthForm" slim>
                  <form role="form" @submit.prevent="">
                    <div class="row">
                      <div class="col-12 form-group">
                        <h5>The following contacts can Create & Amend timesheet instructions for a worker and also Submit
                          to <span v-if="crmType === 'payroll'">Genius</span><span
                            v-else-if="crmType === 'recruitment'">V3</span> for invoicing.</h5>
                      </div>
                      <div v-for="(c, i) in ts_auth.submit_ts" class="col-xl-4 form-group ts_auth_submit">
                        <ValidationProvider rules="required" v-slot="{ errors, classes }"
                          :name="'Submitting Contact' + (i + 1)" tag="div" class="ts_auth_submit_multi">
                          <label class="form-label" :for="'submit_ts_contact_' + i">Submitting Contact {{ i + 1 }}</label>
                          <multiselect v-model="c.contact" placeholder="" :id="'submit_ts_contact_' + i"
                            track-by="contact_id" :options="ms_opts.ts_contacts" :option-height="200" :show-labels="false"
                            class="requiredField" :class="classes" @input="select_ts_contact">
                            <template slot="singleLabel" slot-scope="props">
                              <span class="option__desc_single">
                                <span class="option__title">{{ props.option.person.first_name }} {{
                                  props.option.person.surname }}</span>
                              </span>
                            </template>
                            <template slot="option" slot-scope="props">
                              <div class="option__desc">
                                <span class="option__title">{{ props.option.person.first_name }} {{
                                  props.option.person.surname }}</span>
                                <span class="option__small" v-if="props.option.rel_profile.job_title_id !== null">
                                  {{ props.option.rel_profile.job_title.job_title }}
                                </span>
                              </div>
                            </template>
                          </multiselect>
                          <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                        </ValidationProvider>

                        <button
                          @click.prevent="remove_ts_auth_submitting_contact('Submitting Contact ' + (i + 1), i, c.id)"
                          class="btn orcaBtn danger text-center float-right">X
                        </button>
                      </div>

                      <div v-if="ms_opts.ts_contacts.length > 0 && check_submit_ts_contact_null" class="col-12">
                        <button @click.prevent="add_ts_auth_submitting_contact" class="btn btn-success text-center"><i
                            class="fa fa-plus"></i> Add submitting contact
                        </button>
                      </div>

                    </div>
                    <div class="row">
                      <div class="col-12 form-group">
                        <hr>
                        <h5>The following are contacts who can Create & Amend timesheet instructions for a worker, they
                          authorise an instruction for the contact on the next level
                          or for a contact who can submit to Genius for invoicing.</h5>
                      </div>

                      <div v-for="(c, i) in ts_auth.authorising_ts" class="col-12 form-group">
                        <div class="row">
                          <div class="col-xl-5">
                            <p class="cardLabel pt-0">Authorising Contact Level {{ i + 1 }}</p>
                          </div>
                          <div class="col-xl-4 form-group">
                            <ValidationProvider rules="" v-slot="{ errors, classes }"
                              :name="'Authorising Contact' + (i + 1)" tag="div" class="ts_auth_submit_multi">
                              <label class="form-label" :for="'authorise_ts_contact_' + i">Authorising Contact {{ i + 1
                              }}</label>
                              <multiselect v-model="c.contact" placeholder="" :id="'authorise_ts_contact_' + i"
                                track-by="id" :options="ms_opts.ts_contacts" :option-height="200" :show-labels="false"
                                class="requiredField" :class="classes" @input="select_ts_contact">
                                <template slot="singleLabel" slot-scope="props">
                                  <span class="option__desc_single">
                                    <span class="option__desc_single">
                                      <span class="option__title">{{ props.option.person.first_name }} {{
                                        props.option.person.surname }}</span>
                                    </span>
                                  </span>
                                </template>
                                <template slot="option" slot-scope="props">
                                  <div class="option__desc">
                                    <span class="option__title">{{ props.option.person.first_name }} {{
                                      props.option.person.surname }}</span>
                                    <span class="option__small" v-if="props.option.rel_profile.job_title_id !== null">
                                      {{ props.option.rel_profile.job_title.job_title }}
                                    </span>
                                  </div>
                                </template>
                              </multiselect>
                              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </div>
                          <div class="col-xl-3 form-group">
                            <button
                              @click.prevent="remove_ts_auth_authorising_contact('Authorising Contact ' + (i + 1), i, c.contact_id)"
                              class="btn orcaBtn danger">
                              Remove
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="col-12"
                        v-if="ms_opts.ts_contacts.length > 0 && check_submit_ts_contact_null">
                        <div class="row">
                          <div v-if="ms_opts.ts_contacts.length > 0 && check_submit_ts_contact_null" class="col-12">
                            <button @click.prevent="add_ts_auth_authorising_contact" class="btn btn-success text-center"><i
                                class="fa fa-plus"></i> Add authorising contact
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <hr>
                      </div>
                      <div class="col-xl-6 offset-xl-6 form-group">
                        <button @click.prevent="edit_ts_auth_submit" class="btn orcaBtn" type="submit"
                          :disabled="saving_ts_auth">
                          <span v-if="saving_ts_auth"><i class="fas fa-spinner fa-spin"></i> Saving Default Authorisation
                            & Submission ...</span>
                          <span v-else>Save Default Authorisation & Submission</span>
                        </button>
                      </div>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>

    <div class="col-12">
      <b-card header="All Client Login's" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
        <datatable_client_logins v-if="login_contacts.length > 0" :type="'client_login'" :rowData="login_contacts"
          :loadingMessage="loadingMessage" :noRowsMessage="noRowsMessage" :columns="columns"></datatable_client_logins>
        <div v-else>
          <h5 class="red_color mb-2">There are no contact login's currently for this company</h5>
        </div>
      </b-card>
    </div>

    <!-- VIEW CONTACT LOGIN MODAL -->
    <view_contact_login_modal v-if="$store.state.timesheets.view_login_modal"></view_contact_login_modal>
    <!-- CREATE CONTACT LOGIN MODAL -->
    <create_contact_login_modal v-if="$store.state.timesheets.create_login_modal"></create_contact_login_modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import datatable_client_logins from "datatables/datatable_client_logins";

//modals
import view_contact_login_modal from "partials/modals/contacts/contact_login_view";
import create_contact_login_modal from "partials/modals/contacts/contact_login_create";

export default {
  name: "timesheet_auth_logins",
  components: {
    Multiselect,
    datatable_client_logins,
    view_contact_login_modal,
    create_contact_login_modal
  },
  props: ['default_timesheet_auth', 'default_timesheet_auth_loaded', 'contacts', 'company'],
  data() {
    return {
      ms_opts: {
        ts_contacts: []
      },

      edit_ts_auth: false,
      saving_ts_auth: false,
      ts_auth: {
        authorising_ts: [],
        submit_ts: [
          { contact: null }
        ]
      },

      login_contacts: [],

      loadingMessage: "Loading Client Login's...",
      noRowsMessage: "No Client Login's Found",
      columns: []
    }
  },
  beforeMount() {
    // populate contact list
    this.calc_ts_contacts_in_multiselect();

    if (!this.$store.state.auth.me.roles.includes('client_sub') && !this.$store.state.auth.me.roles.includes('client_auth')) {
      this.columns = [
        { headerName: 'Contact Name', minWidth: 175, pinned: 'left', valueGetter: this.vg_login_name },
        { headerName: 'Contact Job Title', minWidth: 175, valueGetter: this.vg_job_title },
        { headerName: 'Mobile', field: 'phones.work_mobile', minWidth: 105 },
        { headerName: 'Login Email', field: 'user.email', minWidth: 200 },
        { headerName: 'Login Status', minWidth: 125, valueGetter: this.login_status_value_getter },
        { headerName: 'Date Login Created', minWidth: 175, valueGetter: this.date_created_value_getter },
      ]
    }
    else {
      this.columns = [
        { headerName: 'Contact Name', minWidth: 175, pinned: 'left', valueGetter: this.vg_login_name },
        { headerName: 'Contact Job Title', minWidth: 175, valueGetter: this.vg_job_title },
        { headerName: 'Mobile', field: 'phones.work_mobile', minWidth: 105 },
        { headerName: 'Login Status', minWidth: 125, valueGetter: this.login_status_value_getter },
        { headerName: 'Date Login Created', minWidth: 175, valueGetter: this.date_created_value_getter },
      ]
    }
    // Timesheet authentification
    if (this.notEmptyObject(this.default_timesheet_auth)) {
      this.ts_auth.submit_ts = [];
      this.ts_auth.authorising_ts = [];
      for (let i = 0; i < this.default_timesheet_auth.length; i++) {
        if (this.default_timesheet_auth[i].submission_level >= 8) {
          this.ts_auth.submit_ts.push(this.default_timesheet_auth[i])
        }
        else {
          this.ts_auth.authorising_ts.push(this.default_timesheet_auth[i])
        }
      }
      this.calc_ts_contacts_in_multiselect();
    }
    // Client Logins
    this.login_clients_data();
  },
  computed: {
    hasContacts() {
      return this.contacts.length > 0;
    },
    check_submit_ts_contact_null() {
      let check = false;
      for (let i = 0; i < this.ts_auth.submit_ts.length; i++) {
        if ((i + 1) === this.ts_auth.submit_ts.length) {
          if (this.ts_auth.submit_ts[i].contact !== null) {
            check = true;
          }
        }
      }
      return check;
    },
    check_if_authorisation_contacts() {
      let check = false;
      for (let i = 0; i < this.default_timesheet_auth; i++) {
        if (this.default_timesheet_auth[i].submission_level < 8 && this.default_timesheet_auth[i].submission_level > 1) {
          check = true;
        }
      }
      return check;
    },
    submission_auth_as_well() {
      let check = false;
      for (let i = 0; i < this.default_timesheet_auth.length; i++) {
        if (this.default_timesheet_auth[i].submission_level >= 2 && this.default_timesheet_auth[i].submission_level <= 7) {
          check = true;
        }
      }
      return check;
    }
  },
  watch: {
    default_timesheet_auth_loaded(val) {
      if (!val) {
        this.ts_auth = {
          authorising_ts: [],
          submit_ts: [
            { contact: null }
          ]
        }
      }
      else {
        if (this.notEmptyObject(this.default_timesheet_auth)) {
          this.ts_auth.submit_ts = [];
          this.ts_auth.authorising_ts = [];
          for (let i = 0; i < this.default_timesheet_auth.length; i++) {
            if (this.default_timesheet_auth[i].submission_level >= 8) {
              this.ts_auth.submit_ts.push(this.default_timesheet_auth[i])
            }
            else {
              this.ts_auth.authorising_ts.push(this.default_timesheet_auth[i])
            }
          }
          this.calc_ts_contacts_in_multiselect();
        }
      }
    },
    'contacts'() {
      this.login_clients_data();
    }
  },
  methods: {
    vg_login_name(params) {
      return params.data.person.first_name + ' ' + params.data.person.surname;
    },
    vg_job_title(params) {
      if (params.data.rel_profile.job_title_id !== null && params.data.rel_profile.job_title !== null) {
        return params.data.rel_profile.job_title.job_title;
      }
    },
    login_status_value_getter(params) {
      if (params.data.user.active) {
        return 'Active';
      }
      else if (!params.data.user.active) {
        return 'Disabled';
      }
    },
    date_created_value_getter(params) {
      return this.$options.filters.formatDateTime(params.data.user.created_at);
    },

    login_clients_data() {
      this.login_contacts = [];
      if (this.notEmptyObject(this.contacts)) {
        for (let i = 0; i < this.contacts.length; i++) {
          if (this.contacts[i].user !== null && Object.keys(this.contacts[i].user).length > 1) {
            this.login_contacts.push(this.contacts[i])
          }
        }
      }
    },
    /**
     * TIMESHEET AUTHORISATIONS
     */
    calc_ts_contacts_in_multiselect() {
      let passed_contacts = this.contacts;
      for (let i = 0; i < this.ts_auth.submit_ts.length; i++) {
        if (this.ts_auth.submit_ts[i].contact !== null) {
          passed_contacts = passed_contacts.filter(obj => obj.id !== this.ts_auth.submit_ts[i].contact.id)
        }
      }
      for (let i = 0; i < this.ts_auth.authorising_ts.length; i++) {
        if (this.ts_auth.authorising_ts[i].contact !== null) {
          passed_contacts = passed_contacts.filter(obj => obj.id !== this.ts_auth.authorising_ts[i].contact.id)
        }
      }

      this.ms_opts.ts_contacts = [];
      for (let i = 0; i < passed_contacts.length; i++) {
        let job_title = '';
        if ((passed_contacts[i].rel_profile !== null && Object.keys(passed_contacts[i].rel_profile).length > 1) && passed_contacts[i].rel_profile.job_title_id !== null &&
          passed_contacts[i].rel_profile.job_title !== null) {
          job_title = passed_contacts[i].rel_profile.job_title.job_title;
        }
        this.ms_opts.ts_contacts.push({
          company_id: passed_contacts[i].company_id,
          contact_id: passed_contacts[i].id,
          id: passed_contacts[i].id,

          person: {
            first_name: passed_contacts[i].person.first_name,
            surname: passed_contacts[i].person.surname
          },
          rel_profile: {
            job_title_id: passed_contacts[i].rel_profile.job_title_id,
            job_title: {
              job_title: job_title
            }
          }
        })
      }
    },
    add_ts_auth_submitting_contact() {
      this.ts_auth.submit_ts.push({ contact: null });
      this.calc_ts_contacts_in_multiselect();
    },
    remove_ts_auth_submitting_contact(submitting_contact, index, id) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Delete Contact</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure that you wish to remove the client timesheet submitting contact:<br><br>' + submitting_contact +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              // if there are no company level default timesheet authorisations already set up then just splice the submitter contact from the array setting up users
              if (!this.notEmptyObject(this.default_timesheet_auth)) {
                this.$snotify.remove(toast.id);
                // splice contact from array
                this.ts_auth.submit_ts.splice(index, 1);
                // recalculate available contacts for multiselect's
                this.calc_ts_contacts_in_multiselect();
              }
              else {
                // if the contact exists as a saved timesheet submitter already (from database get)
                if (id !== undefined) {
                  // delete the timesheet authorisations record for the contact being removed
                  // (only for orders with default timesheet authorisations and the company authorisations)
                  axios.delete(this.crmApiPath + 'timesheet_authorisation/' + this.company.id + '/' + this.ts_auth.submit_ts[index].contact_id, {
                    params: {
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    }
                  }).then(custom_order_jobs => {
                    // if the timesheet authorisation submitter contact has an ORCA user delete this user
                    // AND isn't on any custom order timesheet authorisations
                    if (this.ts_auth.submit_ts[index].contact.user !== null && Object.keys(this.ts_auth.submit_ts[index].contact.user).length > 1
                      && custom_order_jobs.data.length === 0 && this.ts_auth.submit_ts[index].contact.user.id && this.ts_auth.submit_ts[index].contact.user.id !== null) {
                      // delete the contacts ORCA user
                      axios.delete(this.crmApiPath + 'user/contact/delete/' + this.ts_auth.submit_ts[index].contact.user.id).then(() => {
                        this.$snotify.remove(toast.id);
                        this.ts_auth.submit_ts.splice(index, 1);
                        this.$nextTick(() => {
                          this.$bus.$emit('default_company_ts_auth::reload', { action: true });
                          this.calc_ts_contacts_in_multiselect();
                        })
                      });
                    }
                    // else the timesheet authorisation submitter contact doesn't have a user in ORCA
                    else {
                      this.$snotify.remove(toast.id);
                      // splice the contact from the array of timesheet submitters
                      this.ts_auth.submit_ts.splice(index, 1);
                      this.$nextTick(() => {
                        this.$bus.$emit('default_company_ts_auth::reload', { action: true });
                        this.$nextTick(() => {
                          this.calc_ts_contacts_in_multiselect();
                        })
                      })
                    }
                  });
                }
                // if the contact being added is not a stored timesheet authoriser (added and removed in same edit)
                else {
                  this.$snotify.remove(toast.id);
                  // splice contact from array
                  this.ts_auth.submit_ts.splice(index, 1);
                  // recalculate available contacts for multiselect's
                  this.$nextTick(() => this.calc_ts_contacts_in_multiselect())
                }
              }
            }
          },
          { text: 'No', action: (toast) => this.$snotify.remove(toast.id) }
        ]
      });
    },
    add_ts_auth_authorising_contact() {
      this.ts_auth.authorising_ts.push({ contact: null });
      this.calc_ts_contacts_in_multiselect();
    },
    remove_ts_auth_authorising_contact(authorising_contact, index, id) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Delete Contact</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure that you wish to remove the client timesheet authorising contact:<br><br>' + authorising_contact +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              // if there are no company level default timesheet authorisations already set up then just splice the submitter contact from the array setting up users
              if (!this.notEmptyObject(this.default_timesheet_auth)) {
                this.$snotify.remove(toast.id);
                // splice contact from array
                this.ts_auth.authorising_ts.splice(index, 1);
                // recalculate available contacts for multiselect's
                this.calc_ts_contacts_in_multiselect();
              }
              else {
                // if the contact exists as a saved timesheet submitter already (from database get)
                if (id !== undefined) {
                  // delete the timesheet authorisations record for the contact being removed
                  // (only for orders with default timesheet authorisations and the company authorisations)
                  axios.delete(this.crmApiPath + 'timesheet_authorisation/' + this.company.id + '/' + id, {
                    params: {
                      // Set log values (current crm user)
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    }
                  }).then(custom_order_jobs => {
                    // if the timesheet authorisation submitter contact has an ORCA user delete this user
                    // AND isn't on any custom order timesheet authorisations
                    if (this.ts_auth.authorising_ts[index].contact.user !== null && Object.keys(this.ts_auth.authorising_ts[index].contact.user).length > 1
                      && custom_order_jobs.data.length === 0) {
                      // delete the contacts ORCA user
                      axios.delete(this.crmApiPath + 'user/contact/delete/' + this.ts_auth.authorising_ts[index].contact.user.id).then(() => {
                        this.$snotify.remove(toast.id);
                        this.ts_auth.authorising_ts.splice(index, 1);
                        this.$nextTick(() => {
                          this.$bus.$emit('default_company_ts_auth::reload', { action: true });
                          this.$nextTick(() => this.calc_ts_contacts_in_multiselect())
                        })
                      });
                    }
                    // else the timesheet authorisation submitter contact doesn't have a user in ORCA
                    else {
                      this.$snotify.remove(toast.id);
                      // splice the contact from the array of timesheet submitters
                      this.ts_auth.authorising_ts.splice(index, 1);
                      this.$nextTick(() => {
                        this.$bus.$emit('default_company_ts_auth::reload', { action: true });
                        this.$nextTick(() => {
                          this.calc_ts_contacts_in_multiselect();
                        })
                      })
                    }
                  });
                }
                // if the contact being added is not a stored timesheet authoriser (added and removed in same edit)
                else {
                  this.$snotify.remove(toast.id);
                  // splice contact from array
                  this.ts_auth.authorising_ts.splice(index, 1);
                  // recalculate available contacts for multiselect's
                  this.$nextTick(() => this.calc_ts_contacts_in_multiselect())
                }
              }
            }
          },
          { text: 'No', action: (toast) => this.$snotify.remove(toast.id) }
        ]
      });
    },
    select_ts_contact() {
      this.calc_ts_contacts_in_multiselect();
      this.$nextTick(() => {
        if (this.ms_opts.ts_contacts.length === 0) {
          for (let i = 0; i < this.ts_auth.submit_ts.length; i++) {
            this.ts_auth.submit_ts = this.ts_auth.submit_ts.filter(item => item.contact !== null)
          }
          for (let i = 0; i < this.ts_auth.authorising_ts.length; i++) {
            this.ts_auth.authorising_ts = this.ts_auth.authorising_ts.filter(item => item.contact !== null)
          }
        }
      });
    },
    edit_levels() {
      this.calc_ts_contacts_in_multiselect();
      this.edit_ts_auth = true;
    },
    edit_ts_auth_submit() {
      this.reloadTimesheetAuthorisations().then(() => {
        this.saving_ts_auth = false;
        this.edit_ts_auth = false;
        this.$nextTick(() => {
            this.$bus.$emit('default_company_ts_auth::reload', { action: true });
        });
      });
    },
    reloadTimesheetAuthorisations() {
      return new Promise((resolve, reject) => {
        this.$refs.editTSauthForm.validate().then(success => {
          if (!success) {
            this.formErrorsValidationScroll(this.$refs.editTSauthForm);
            reject();
          }
          else {
            this.saving_ts_auth = true;
            // define the lowest level for timesheet authorisation submission level for auth & submit
            let auth_sub_level_start = 2, submit_sub_level_start = 8;
            let promises = [];
            // save timesheet authorisation & submit contacts
            for (const [i, value] of this.ts_auth.submit_ts.entries()) {
                if (value.hasOwnProperty('id')) {
                    let ts_auth = {
                      company_id: this.company.id,
                      submission_level: submit_sub_level_start,
                      contact_id: value.contact.id,
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    };

                    promises.push(new Promise(resolveItem => {
                      axios.patch(this.crmApiPath + 'timesheet_authorisation/' + value.id, ts_auth).then(() => resolveItem());
                    }));
                }
                else {
                    let ts_auth = {
                      company_id: this.company.id,
                      submission_level: submit_sub_level_start,
                      contact_id: value.contact.contact_id,
                      log_by_type: 'App\\Models\\Users\\User',
                      log_by_id: this.$store.state.auth.me.id
                    };

                    promises.push(new Promise(resolveItem => {
                      axios.post(this.crmApiPath + 'timesheet_authorisation', ts_auth).then(() => resolveItem());
                    }));
                }
            }

            for (const [i, value] of this.ts_auth.authorising_ts.entries()) {
              if (value.hasOwnProperty('id')) {
                  let ts_auth = {
                    company_id: this.company.id,
                    submission_level: auth_sub_level_start,
                    contact_id: value.contact.id,
                    log_by_type: 'App\\Models\\Users\\User',
                    log_by_id: this.$store.state.auth.me.id
                  };

                  promises.push(new Promise(resolveItem => {
                    axios.patch(this.crmApiPath + 'timesheet_authorisation/' + value.id, ts_auth).then(() => resolveItem());
                  }));

              }
              else {
                let ts_auth = {
                  company_id: this.company.id,
                  submission_level: auth_sub_level_start,
                  contact_id: value.contact.contact_id,
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                };

                promises.push(new Promise(resolveItem => {
                  axios.post(this.crmApiPath + 'timesheet_authorisation', ts_auth).then(() => resolveItem());
                }));
              }
            }

            Promise.all(promises)
            .then(() => {
              resolve();
            })
            .catch(error => {
              reject(error);
            });

          }
        });
      });
    },
    /**
     * TIMESHEET AUTHORISATIONS : Create & View Login for Contact
     */
    create_contact_login(contact, contact_sub_level) {
      this.$store.commit('SHOW_CREATE_CONTACT_LOGIN_MODAL', {
        contact: contact,
        contact_level: contact_sub_level
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'create_contact_login_modal'));
    },
    view_contact_login(contact) {
      this.$store.commit('SHOW_VIEW_CONTACT_LOGIN_MODAL', {
        contact: contact
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'view_contact_login_modal'));
    },
    enable_contact_login(contact) {
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Enable User Login</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure that you wish to enable this users login:<br><br>' + contact.full_name +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);

              let enable_user = {
                id: contact.user.id,
                active: true
              };

              axios.patch(this.crmApiPath + 'user/contact/enable/' + contact.user.id, enable_user).then(() => {
                this.$nextTick(() => {
                  this.$bus.$emit('default_company_ts_auth::reload', { action: true });
                  this.$bus.$emit('contacts::reload', { type: 'contact', action: true });
                })
              })
            }
          },
          { text: 'No', action: (toast) => this.$snotify.remove(toast.id) }
        ]
      });
    }
  }
}
</script>

<style lang="scss">
.ts_auth_submit {
  .ts_auth_submit_multi {
    width: calc(100% - 50px);
    display: inline-block;
  }

  .orcaBtn.danger {
    width: 35px;
    height: 35px;
    line-height: 30px;
    padding: 0;
    margin-top: 5px;
  }

  &.first {
    .ts_auth_submit_multi {
      width: 100%;
      display: block;
    }
  }
}

.ts_auth_submit_multi {
  .multiselect__option {
    height: auto !important;
  }

  .option__desc {
    .option__title {
      font-weight: bold;
      display: block;
    }

    .option__small {
      font-size: 0.7rem;
      display: block;
    }
  }
}

.sm_btn {
  display: inline-block;
  width: auto;
  padding: 0 15px;
  line-height: 30px;
  font-size: 0.65rem;
}

.contact_login_text {
  display: inline-block;
  width: calc(100% - 100px);
}

.contact_login_btn {
  display: inline-block;
  width: 90px;
  text-align: right;
}</style>
